/**
 * manager 相关工具函数
 */

enum DriveMessageType {
    STATUS_REPORT = 'DRIVE_MESSAGE_STATUS_REPORT',
}

/**
 * 预览态场景，页面加载完成后向drive发送通知事件
 * @param isSuccess 加载成功
 */
export function postMessageToDrive(isSuccess: boolean): void {
    window.parent.postMessage({
        type: DriveMessageType.STATUS_REPORT,
        data: { isSuccess },
    }, '*');
}
